module.exports = __webpack_public_path__ + "img/dequavian_1.4e935cd5.gif";